interface DiscountedFeeProps {
	actualPrice: number
	discountedPrice: number
	currency: string
}

const DiscountedFee = ({
	actualPrice,
	discountedPrice,
	currency,
}: DiscountedFeeProps) => {
	return (
		<>
			<span>
				{currency} {discountedPrice}{" "}
			</span>
			{discountedPrice !== actualPrice && (
				<span className="text-[#EC6D62] line-through">
					{actualPrice}
				</span>
			)}
		</>
	)
}

export default DiscountedFee
